import { createAction } from '@reduxjs/toolkit';
import { LandingPageAccess } from '../types';

export const requestLandingPageAccess = createAction(
	'requestLandingPageAccess/get',
);
export const requestLandingPageAccessResolved = createAction<LandingPageAccess>(
	'requestLandingPageAccess/resolved',
);
export const requestLandingPageAccessRejected = createAction(
	'requestLandingPageAccess/rejected',
);
